import React, {useEffect, useState} from "react";
import { Typography,
    Grid,
    makeStyles,
    Container,
    Card,
    useMediaQuery,
    useTheme,
    Button} from "@material-ui/core";
import { ReactComponent as PetPaw } from "../../Images/petPaw.svg";
import { RootState, useAppDispatch } from "../../redux/store";
import { useSelector } from "react-redux";
import Navigation from "../../Components/Navigation/Navigation";
import { getUserByID } from "../../redux/user/user.actions";
import moment from "moment";
import API from "../../helpers/apiHelpers";
import Logo from "../../Images/logoNew.png";
import jsPDF from "jspdf";

const useStyle = makeStyles(() => ({
    cardRoot: {
        width: "100%",
        padding: 40,
        marginBottom: 32,
    },
    containerRoot: {
        paddingTop: 100,
        marginBottom: 55,
        zIndex: 1,
    },
    body: {
        paddingTop: 20,
    },
    spacing: {
        paddingTop: 20,
    },
    spacingImage: {
        paddingTop: 20,
        display: "flex"
    },
}));

interface Props {
    title: string;
    details: string;
    color: string;
}

const PawCard = ({title, details, color} : Props) => {
    return (
        <Grid container item xs={12} justify="center" alignContent="center" style={{paddingBottom: 10}}>
            <Grid item xs={2} alignItems="center">
                <PetPaw fill= {color} style={{height: "100%", width: 40, display: "block", margin: "0 auto"}} />
            </Grid>
            <Grid item container xs={10} direction="column">
                <Typography variant="body2">{title}</Typography>
                <Typography color="textSecondary">{details}</Typography>
            </Grid>
        </Grid>
    );
};

const SubscriptionDetails = () => {
    const classes=useStyle();
    const user = useSelector((state: RootState) => state?.user);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const dispatch = useAppDispatch();
    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState(moment());
    const [loaded, setLoaded] = useState(false);
    const [subId, setSubId] = useState(0);
    const [logoB64, setLogoB64] = useState("");
    const [profile, setProfile] = useState<any>();

    useEffect(() => {
        window.scrollTo(0,0);
    }, []);

    useEffect(() => {
        if (user.userId){
            dispatch(getUserByID(user.userId)).then(res => {
                if (res.ownerSubscriptionPlans?.length > 0){
                    setStartDate(moment(res.ownerSubscriptionPlans[0].created));
                    setEndDate(moment(res.ownerSubscriptionPlans[0].created).add(1,"y").subtract(1,"d"));
                    setSubId(res.ownerSubscriptionPlans[0].id);
                    setLoaded(true);
                }
            });
            API.getProfiles({
                userId: API.userId
            }).then(res => {
                if (res){
                    setProfile(res[0]);
                }
            });
            convertBase64(Logo);
        }
    }, []);

    const convertBase64 = async (img) => {
        // blob to dataURL
        function blobToDataURL(blob, callback) {
            var a = new FileReader();
            a.onload = function(e) {callback(e.target.result);};
            a.readAsDataURL(blob);
        }
        const file = await fetch(img).then(res => res.blob());
        blobToDataURL(file, function(dataurl){
            setLogoB64(dataurl);
        });
	  };

    const handleReceipt = () => {
        const doc = new jsPDF();
        const firstName = profile ? profile.firstName : "";
        const lastName = profile ? profile.lastName : "";
        doc.addImage(logoB64, 10, 7, 20, 20, "logo", "NONE", 0);
        doc.setFontSize(12);
        doc.text("Contact Us", 100, 10, {align: "center"});
        doc.text("hello@thevideovets.com", 100, 17, {align: "center"});
        doc.text("1621 Central Ave.", 180, 10, {align: "center"});
        doc.text("Cheyenne, WY 82001", 180, 17, {align: "center"});
        doc.setFontSize(16);
        doc.text("Unlimited Appointment Receipt", 10, 50);
        doc.setFontSize(12);
        doc.text("Subscription ID", 15, 60);
        doc.text("Client", 15, 67);
        //change color:
        doc.setTextColor(138,138,138);
        doc.text(subId.toString(), 50, 60);
        doc.text(`${firstName} ${lastName}`, 50, 67);
        //HR
        doc.setTextColor(0);
        doc.line(10, 87, 200, 87);
        //Line Items:
        doc.setFontSize(16);
        doc.text("Description", 15, 97);
        doc.text("Amount", 140, 97);
        doc.setFontSize(12);
        doc.text("Unlimited Appointment Fee", 15, 107);
        doc.setTextColor(138,138,138);
        doc.text("$119.00", 140, 107);
        //Payment lines:
        doc.setTextColor(0);
        doc.text("Total", 120, 127);
        doc.text("Payment Method", 97.5, 137);
        doc.setTextColor(138,138,138);
        doc.text("$119.00", 140, 127);
        doc.text("Credit Card", 140, 137);
        //Footer
        doc.setFontSize(10);
        doc.text("Thank you for choosing The Video Vets!", 100, 155, {align: "center"});
        doc.save(`unlimitedAppointments_${subId}.pdf`);
    };

    return(
        <Container className={classes.containerRoot} maxWidth="md">
            <Grid container>
                {!isMobile &&
                    <Grid item md={3} xs={12}>
                    	<Navigation />
                    </Grid>
                }
                <Grid item md={9} xs={12}>
                    <Card className={classes.cardRoot}>
                        <Container className={classes.body} disableGutters={true}>
                            <Grid container spacing={2}>
                                <Grid item container xs={12} alignItems="center" justify="center">
                                    <Grid item xs={12}>
                                        <Typography variant="h2" style={{fontSize: 36, paddingBottom: 25}}>
                                            Unlimited Appointment Details
                                        </Typography>
                                    </Grid>
                                </Grid>
                                {loaded &&
                                    <Grid item xs={12} container>
                                    	<Grid item xs={12} sm={6}>
                                    		<span style={{fontWeight: 700}}>Start Date:</span> {startDate.format("LL")}
                                    	</Grid>
                                    	<Grid item xs={12} sm={6}>
                                    		<span style={{fontWeight: 700}}>End Date:</span> {endDate.format("LL")}
                                    	</Grid>
                                    </Grid>
                                }
                                <Grid item xs={12} style={{paddingTop: 20}}>
                                    <PawCard
                                        title="Unlimited Appointments"
                                        details="Access expert advice with licensed veterinarians for an entire year."
                                        color={theme.palette.primary.main}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <PawCard
                                        title="15% Off Prescription Visits"
                                        details="Save 15% on visits that include vet prescribed medication, where available*"
                                        color={theme.palette.primary.main}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <PawCard
                                        title="Flexible Scheduling"
                                        details="Request an appointment ASAP or schedule for a future date"
                                        color={theme.palette.primary.main}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <PawCard
                                        title="Real-time Answers via Video or Chat"
                                        details="Connect however you feel most comfortable- whether you prefer live video or text-based chat, you can access veterinary care on our website or mobile app."
                                        color={theme.palette.primary.main}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        type="button"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleReceipt}
                                    >
                                        Download Receipt
                                    </Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="caption">* Available in NJ, NY, MI, OK, VA based on state regulations</Typography>
                                </Grid>
                            </Grid>
                        </Container>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
};

export default SubscriptionDetails;
